export default __webpack_public_path__ + "static/media/_default-img.52c4f284.svg";